import {Component, OnInit}       from "@angular/core";
import {AuthService}             from "src/app/services/auth/auth.service";
import {Router} from "@angular/router";
import {FormControl, Validators} from "@angular/forms";
import  {environment} from "../../../environments/environment";

@Component({
    selector:    "app-login-screen",
    templateUrl: "./login-screen.component.html",
    styleUrls:   ["./login-screen.component.scss"]
})
export class LoginScreenComponent implements OnInit {

    loginObj = {
        email: new FormControl("", [Validators.required]),
        senha: new FormControl("", [Validators.required, Validators.minLength(2)])
    };

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    ngOnInit(): void {
        if (this.authService.isLoggedIn) {
            this.router.navigate(["/"]);
        }
    }

    async submitLogin() {
        if (this.loginObj.email.invalid) {
            return false;
        }

        if (this.loginObj.senha.invalid) {
            return false;
        }

        await this.authService.login({
            email: this.loginObj.email.value,
            password: this.loginObj.senha.value
        });
    }

    getErrorMessage() {
        if (this.loginObj.email.hasError("required")) {
            return "Informe seu email";
        }

        return this.loginObj.email.hasError("email") ? "Não é um email válido" : "";
    }

}
